module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_features_02-fa2f5ea1541f871211c83290779ffb82.png";